import { reducer as userConfigurationReducer } from '@noths/polaris-client-user-configuration';
import { reducer as favouritesReducer } from '@noths/polaris-client-user-favourites';
import { combineReducers } from '@reduxjs/toolkit';
import { routerReducer } from 'connected-next-router';

import { reducer as productImagesCarouselReducer } from 'src/components/organisms/ProductImagesCarousel';
import { reducer as contactPartnerModalReducer } from 'src/redux/contactPartner';
import { reducer as contentReducer } from 'src/redux/content/slice';
import { reducer as productInfoReducer } from 'src/redux/productInfo/slice';
import { reducer as accessibilityReducer } from './accessibility';
import { reducer as basketReducer } from './basket';
import { reducer as deliveryReducer } from './delivery/slice';
import { reducer as personalisationReducer } from './personalisation/slice';
import { reducer as productReducer } from './product';
import { reducer as reviewsReducer } from './reviews/slice';
import { reducer as richRelevanceReducer } from './richRelevance/slice';

export const combinedReducer = combineReducers({
  accessibility: accessibilityReducer,
  basket: basketReducer,
  contactPartnerModal: contactPartnerModalReducer,
  content: contentReducer,
  delivery: deliveryReducer,
  favourites: favouritesReducer,
  personalisation: personalisationReducer,
  product: productReducer,
  productImagesCarousel: productImagesCarouselReducer,
  productInfo: productInfoReducer,
  reviews: reviewsReducer,
  richRelevance: richRelevanceReducer,
  router: routerReducer,
  userConfiguration: userConfigurationReducer,
});

export type ReduxApplicationState = ReturnType<typeof combinedReducer>;
